import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import { activeLocale, dynamicLocaleImport } from '../locale';
/**
 * Return the distance between the given date and now in words.
 * @param {Date|string} dirtyDate
 * @param {Options} dirtyOptions
 */

var distanceInWordToNow = function distanceInWordToNow(dirtyDate, dirtyOptions) {
  var currentLocale = dirtyOptions && dirtyOptions.locale || activeLocale;
  return distanceInWordsToNow(dirtyDate, _objectSpread({}, dirtyOptions, {
    locale: dynamicLocaleImport(currentLocale)
  }));
};

export default distanceInWordToNow;